angular.module('zc.projects')

.controller 'ImagesCtrl', ["$scope", "images", "Image", ($scope, images, Image) ->
  $scope.images = images
  $scope.selected = {}
  currentImageUrl = ""

  $scope.deleteImage = (id) ->
    destroy = Image.destroy({imageId: id})
    destroy.then (res) ->
      $scope.images = res.images

  for img in $scope.images
    if img.image_url == currentImageUrl
      $scope.selected.img = img

  $scope.selectImage = (img) ->
    $scope.selected.img = img

  $scope.ok = () ->
    $modalInstance.close($scope.selected.img)

  $scope.cancel = () ->
    $modalInstance.dismiss('cancel')
]



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects/controllers/images/index.js.coffee